module.exports = __webpack_public_path__ + "static/img/logo_pic.e84429b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_pic.png
// module id = jAWD
// module chunks = 1